export const isArray = data => {
  if(data && Array.isArray(data) && data.length) return true
  return false
}